import * as React from 'react';
import { useSignMessage, useAccount } from 'wagmi';
import { recoverMessageAddress } from 'viem';
import { apiUrl } from '../utils/constants.ts';

export function SignMessage({
  FunAddress,
  sender,
  content,
  timestamp
}) {
  const { data: signMessageData, isLoading, signMessage, variables, reset } = useSignMessage();
  const { address } = useAccount();

  React.useEffect(() => {
    (async () => {
      if (variables?.message && signMessageData) {
        const recoveredAddress = await recoverMessageAddress({
          message: variables?.message,
          signature: signMessageData,
        });
        if (recoveredAddress) {
          const sendData = {
            FunAddress: FunAddress,
            sender: sender,
            content: variables?.message,
            timestamp: timestamp
          };
          const response = await fetch(apiUrl + '/add', {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
              'Content-Type': 'application/json'
            },
            redirect: 'error',
            body: JSON.stringify(sendData)
          });
          reset();
          document.getElementById("message").value = "";
          if (response.status !== 200) {
            const { error } = await response.json();
            throw new Error(error);
          }
        }
      }
    })();
  }, [signMessageData, variables?.message]);

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const message = formData.get('message');
        signMessage({ message });
      }}
    >
      <div className="mb-4">
        <textarea
          id="message"
          name="message"
          placeholder="Type your message here"
          className="w-full p-4 rounded-xl focus:outline-none"
          rows={4}
          style={{
            background: 'var(--input-bg)',
            border: '1px solid var(--input-border)',
            color: 'var(--text-primary)',
            resize: 'vertical'
          }}
        />
      </div>
      <button
        disabled={isLoading || address === undefined}
        className="w-full py-3 rounded-lg font-bold transition-all disabled:opacity-50 disabled:cursor-not-allowed"
        style={{
          background: 'var(--primary-gradient)',
          color: 'var(--button-text)'
        }}
      >
        {address === undefined ? 'Connect Wallet First' : isLoading ? 'Check Wallet' : 'Send Message'}
      </button>
    </form>
  );
}
